export default {
  en: {
    title: "Assessments",
    assessment: "Assessment",
    list: {
      title: "Assessments",
      filters: {
        true: "Show Draft",
        false: "Show Completed"
      },
      buttons: {
        cleanFilters: "Clean Filters",
        new: "Create New Assessment"
      },
      table: {
        progress: "Progress",
        score: "Score",
        created_at: "Date",
        created_by: "Created By",
        status: "Acceptance",
        draft: "Draft",
        coverage: "Coverage",
        itemMenu: {
          view: "View Assessment",
          download: "Download Report",
          continue: "Continue Assessment"
        }
      }
    },
    status: {
      waiting: "Waiting",
      waitingTooltip: "Acceptance not submitted",
      not_ready: "Not Ready",
      not_readyTooltip: "Assessment not yet finished",
      accepted: "Accepted",
      acceptedTooltip: "Accepted by {name} on {date}"
    },
    score: {
      notAvailable: "Not Available"
    },
    create: {
      saveDraft: "Save Draft",
      nextBlock: "Next Question Block",
      previousBlock: "Previous Question Block",
      nextMitigationBlock: "Next Mitigation Block",
      previousMitigationBlock: "Previous Mitigation Block",
      finishAssessmentButton: "Finish Assessment",
      generateReport: "Generate Report",
      questionBlock: "Question Block",
      addAttachment: "Add Attachment",
      justify: "Justify",
      recommendation: "Recommendation",
      notHasRecommendation: "Has recommendation",
      responseOptions: {
        implemented: "Implemented",
        notImplemented: "Not Implemented",
        partiallyImplemented: "Partially Implemented",
        notApplicable: "N/A"
      },
      titles: {
        step1: "Create New Assessment",
        step2: "Review Partially Implemented",
        step3: "Review Not Implemented",
        step4: "Review Assessment"
      },
      confirmAcceptance: "Confirm Acceptance",
      downloadAnswers: "Download Answer List",
      checkAcceptance: "Check Acceptance",
      downloadReport: "Download Report",
      clientName: "Client Name",
      clientNamePlaceholder: "Insert client complete name",
      saveAcceptance: "Save Acceptance",
      saveAcceptanceModalTitle: "Saving Acceptance terms",
      saveAcceptanceModalText:
        "If you save the acceptance evidence this document cannot be edited, are you sure you want this?",
      seeSubtechniques: "See Subtechniques",
      total: "{qty} total"
    },
    modal: {
      remove: {
        title: "Remove Assessment? | Remove Assessments?",
        text: "Are you sure that you want to remove the selected Assessment from your data base? | Are you sure that you want to remove the selected Assessments from your data base?"
      }
    }
  },
  pt: {
    title: "Avaliações",
    assessment: "Avaliação",
    list: {
      title: "Avaliações",
      filters: {
        true: "Mostrar Rascunhos",
        false: "Mostrar Concluídos"
      },
      buttons: {
        cleanFilters: "Limpar Filtros",
        new: "Criar nova Avaliação"
      },
      table: {
        progress: "Progresso",
        score: "Pontuação",
        created_at: "Data",
        created_by: "Criado Por",
        status: "Aceitação",
        draft: "Rascunho",
        coverage: "Cobertura",
        itemMenu: {
          view: "Ver Avaliação",
          download: "Baixar Relatório",
          continue: "Continuar Avaliação"
        }
      }
    },
    status: {
      waiting: "Aguardando",
      waitingTooltip: "Aceitação não enviada",
      not_ready: "Não Finalizado",
      not_readyTooltip: "Avaliação ainda não concluída",
      accepted: "Aceito",
      acceptedTooltip: "Aceito por {name} em {date}"
    },
    score: {
      notAvailable: "Não Disponível"
    },
    create: {
      saveDraft: "Salvar Rascunho",
      nextBlock: "Próximo Bloco de Perguntas",
      previousBlock: "Bloco de Perguntas Anterior",
      nextMitigationBlock: "Próximo Bloco de Mitigação",
      previousMitigationBlock: "Bloco de Mitigação Anterior",
      finishAssessmentButton: "Finalizar Avaliação",
      generateReport: "Gerar Relatório",
      questionBlock: "Bloco de Perguntas",
      addAttachment: "Adicionar Anexo",
      justify: "Justificativa",
      recommendation: "Recomendação",
      notHasRecommendation: "Há recomendação",
      responseOptions: {
        implemented: "Implementado",
        notImplemented: "Não Implementado",
        partiallyImplemented: "Parcialmente Implementado",
        notApplicable: "N/A"
      },
      titles: {
        step1: "Criar nova Avaliação",
        step2: "Revisar Parcialmente Implementado",
        step3: "Revisar Não Implementado",
        step4: "Revisar Avaliação"
      },
      confirmAcceptance: "Confirmar a Aceitação",
      downloadAnswers: "Baixar Lista de Respostas",
      checkAcceptance: "Checar Aceite",
      downloadReport: "Baixar Relatório",
      clientName: "Nome do Cliente",
      clientNamePlaceholder: "Inserir o nome completo do cliente",
      saveAcceptance: "Salvar Aceitação",
      saveAcceptanceModalTitle: "Termos para salvar a Aceitação",
      saveAcceptanceModalText:
        "Se você salvar a evidência de aceitação, este documento não poderá ser editado. Tem certeza de que deseja isso?",
      seeSubtechniques: "Ver Subtécnicas",
      total: "{qty} total"
    },
    modal: {
      remove: {
        title: "Remover Avaliação? | Remover Avaliações?",
        text: "Tem certeza de que deseja remover a Avaliação selecionada da sua base de dados? | Tem certeza de que deseja remover as Avaliações selecionadas da sua base de dados?"
      }
    }
  },
  es: {
    title: "Evaluaciones",
    assessment: "Evaluación",
    list: {
      title: "Evaluaciones",
      filters: {
        true: "Mostrar Borrador",
        false: "Mostrar Completado"
      },
      buttons: {
        cleanFilters: "Limpiar Filtros",
        new: "Crear nueva Evaluación"
      },
      table: {
        progress: "Progreso",
        score: "Puntuación",
        created_at: "Fecha",
        created_by: "Creado Por",
        status: "Aceptación",
        draft: "Borrador",
        coverage: "Portada",
        itemMenu: {
          view: "Ver Evaluación",
          download: "Descargar Informe",
          continue: "Continuar la Evaluación"
        }
      }
    },
    status: {
      waiting: "En Espera",
      waitingTooltip: "Aceptación no enviada",
      not_ready: "No Finalizado",
      not_readyTooltip: "Evaluación aún no finalizada",
      accepted: "Aceptado",
      acceptedTooltip: "Aceptado por {name} en {date}"
    },
    score: {
      notAvailable: "No Disponible"
    },
    create: {
      saveDraft: "Guardar Borrador",
      nextBlock: "Siguiente Bloque de Preguntas",
      previousBlock: "Bloque de Preguntas Anterior",
      nextMitigationBlock: "Siguiente Bloque de Mitigación",
      previousMitigationBlock: "Bloque de Mitigación Anterior",
      finishAssessmentButton: "Finalizar la Evaluación",
      generateReport: "Generar Informe",
      questionBlock: "Bloque de Preguntas",
      addAttachment: "Añadir Anexo",
      justify: "Justificación",
      recommendation: "Recomendaciones",
      notHasRecommendation: "Existe una recomendación",
      responseOptions: {
        implemented: "Implantado",
        notImplemented: "No Aplicado",
        partiallyImplemented: "Aplicado Parcialmente",
        notApplicable: "No Aplicable"
      },
      titles: {
        step1: "Crear una nueva Evaluación",
        step2: "Revisión Aplicado Parcialmente",
        step3: "Revisión No Aplicado",
        step4: "Revisión de la Evaluación"
      },
      confirmAcceptance: "Confirmar Aceptación",
      downloadAnswers: "Descargar Lista de Respuestas",
      checkAcceptance: "Comprobar la Aceptación",
      downloadReport: "Descargar Informe",
      clientName: "Nombre del Cliente",
      clientNamePlaceholder: "Introduzca el nombre completo del cliente",
      saveAcceptance: "Guardar Aceptación",
      saveAcceptanceModalTitle: "Condiciones para guardar la Aceptación",
      saveAcceptanceModalText:
        "Si guarda la prueba de aceptación, este documento no podrá editarse. ¿Está seguro de que desea esto?",
      seeSubtechniques: "Ver Subtécnicas",
      total: "{qty} total"
    },
    modal: {
      remove: {
        title: "¿Quitar Evaluación? | Quitar Evaluaciones",
        text: "¿Está seguro de que desea eliminar la Evaluación seleccionada de su base de datos? | ¿Está seguro de que desea eliminar las Evaluaciones seleccionadas de su base de datos?"
      }
    }
  }
}
